export default __webpack_public_path__ + "static/media/gesture.6a05c32f.svg";